<template>
    <div class="ss-live-page">
        <banner-video :vm="aiBanner"></banner-video>
        <img-box :vm="supportAiList"></img-box>
        <aptitude></aptitude>
        <technology></technology>
        <self-equipment></self-equipment>
        <subject-intro main="英语·数学，动态场景让学习更加有趣" sub="让学生不仅爱上学习，还要在快乐中学习" :hasSub="hasSub"></subject-intro>
        <love-learn></love-learn>
    </div>
</template>
<script>
import bannerVideo from './components/banner-video'
import aptitude from './components/ai/aptitude'
import technology from './components/ai/technology'
import selfEquipment from './components/self-equipment'
import subjectIntro from './components/subject-intro'
import imgBox from './components/img-box.vue'
import loveLearn from './components/ai/love-learn'
import { aiBanner, supportAiList,  liveOperateList } from '@/const'
export default {
    data () {
        return {
            aiBanner: aiBanner,
            supportAiList: supportAiList,
            hasSub: [2, 3],
            liveOperateList: liveOperateList
        }
    },
    components: { bannerVideo, aptitude, technology,  selfEquipment, subjectIntro, imgBox, loveLearn }
}
</script>
